import { useStytchMemberSession } from '@stytch/react/b2b';
import React from 'react';

import type { ContainerComponent } from '../../common/types/Common';
import { captureMessage } from '../../logger/Logger';
import HandleRedirectFromStorage from './HandleRedirectFromStorage';

const RedirectIfAuthenticated: ContainerComponent = ({ children }) => {
    const { session } = useStytchMemberSession();

    if (session) {
        // User is authenticated and on a sign-in page, redirect them back to where they were trying to go
        captureMessage(
            `Authenticated session found. Redirecting to / from ${window.location.pathname}`,
        );
        return <HandleRedirectFromStorage />;
    }

    return <>{children}</>;
};

export default RedirectIfAuthenticated;
